/**
 * core/fonts.js
 * Quản lý cấu hình font chữ cho Canvas Texture và đảm bảo font đã tải xong trước khi render.
 */

export const CANVAS_FONTS = {
  sans: '"Be Vietnam Pro", "Plus Jakarta Sans", sans-serif',
  serif: '"Lora", "Be Vietnam Pro", serif',
  display: '"Be Vietnam Pro", sans-serif'
};

const REQUIRED_FONTS = [
  '500 16px "Be Vietnam Pro"',
  '700 16px "Be Vietnam Pro"',
  '800 16px "Be Vietnam Pro"',
  '500 16px "Lora"',
  '700 16px "Lora"'
];

export async function ensureCanvasFonts(timeoutMs = 3000) {
  if (typeof document === 'undefined') {
    return true;
  }

  const startTime = Date.now();

  try {
    // 1. Kiểm tra và đợi stylesheet Google Fonts nạp xong (nếu có thẻ link)
    const link =
      (typeof document.getElementById === 'function' ? document.getElementById('font-stylesheet') : null) ||
      (typeof document.querySelector === 'function'
        ? document.querySelector('link[href*="fonts.googleapis.com"]')
        : null);

    if (link && !link.sheet && typeof link.addEventListener === 'function') {
      const waitTime = Math.max(100, timeoutMs - (Date.now() - startTime));
      await new Promise((resolve) => {
        let timer = setTimeout(resolve, waitTime);
        const onDone = () => {
          clearTimeout(timer);
          link.removeEventListener?.('load', onDone);
          link.removeEventListener?.('error', onDone);
          resolve();
        };
        link.addEventListener('load', onDone, { once: true });
        link.addEventListener('error', onDone, { once: true });
      });
    }

    if (!document.fonts || typeof document.fonts.load !== 'function') {
      return true;
    }

    // 2. Nạp các font faces cần thiết cho canvas texture
    const elapsed = Date.now() - startTime;
    const remainingTime = Math.max(100, timeoutMs - elapsed);

    const loadPromise = Promise.all(REQUIRED_FONTS.map((fontDesc) => document.fonts.load(fontDesc).catch(() => [])));

    let timer;
    const timeoutPromise = new Promise((resolve) => {
      timer = setTimeout(() => resolve('timeout'), remainingTime);
    });

    await Promise.race([loadPromise, timeoutPromise]);
    if (timer) clearTimeout(timer);

    if (document.fonts.ready) {
      const postElapsed = Date.now() - startTime;
      const postRemaining = Math.max(100, timeoutMs - postElapsed);
      await Promise.race([
        document.fonts.ready.catch(() => {}),
        new Promise((resolve) => setTimeout(resolve, Math.min(500, postRemaining)))
      ]);
    }
    return true;
  } catch (err) {
    console.warn('[Fonts] Không thể nạp font canvas trước:', err);
    return false;
  }
}
